import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

import { HttpClientService } from '../common/http-client.service';

export interface PhoneCallBillingContext {
  phoneNumber: string;
  contactName: string;
  matterId?: number;
}

@Injectable()
export class PhoneCallBillingService {
  modalOpen$: Subject<PhoneCallBillingContext> = new Subject();

  private phoneNumbersURL: string = 'phone_numbers';

  constructor(private httpClient: HttpClientService, private router: Router) {}

  openModal(phoneNumber: string, contactName: string, matterId?: number): void {
    if (!matterId) {
      matterId = this.detectMatterFromRoute();
    }
    this.modalOpen$.next({ phoneNumber, contactName, matterId });
  }

  makeCall(destination: string): Promise<any> {
    return this.httpClient.post(`${this.phoneNumbersURL}/make_call.json`, { destination });
  }

  findMattersForPhoneNumber(phoneNumber: string): Promise<any> {
    return this.httpClient.get(`${this.phoneNumbersURL}/find_matters.json`, { number: phoneNumber });
  }

  private detectMatterFromRoute(): number | undefined {
    const match = this.router.url.match(/\/matters\/(\d+)/);
    return match ? Number(match[1]) : undefined;
  }
}
